import { useAuth } from "@/modules/auth/hooks/use-auth"
import { AppRole } from "@/modules/auth/constants/app-role"

/** Only the Organization Owner can open "Manage access" and assign/revoke — matches the
 * OrganizationOwner-only check in AssignResourceAccessHandler/RevokeResourceAccessHandler. */
export function useCanManageAccess() {
  const { hasRole } = useAuth()
  return hasRole(AppRole.OrganizationOwner)
}
